import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { HeaderButtonDirective } from './header-button/header-button.directive';
import { HeaderDataChanged, HeaderService } from '../../../services/header.service';
import { HeaderButton } from './header-button/header-button.interface';
import { filter } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { hasValue } from '../../../utils/functions/common.functions';

@UntilDestroy()
@Component({
  selector: 'app-header-base',
  templateUrl: './header-base.component.html',
  styleUrls: ['./header-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBaseComponent implements OnInit {

  @Input() public title: string = '';
  @Input() public subtitle?: string | null = null;

  @ViewChild(HeaderButtonDirective, { static: true })
  private headerButton!: HeaderButtonDirective;

  public showBackButton: boolean = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    private headerService: HeaderService,
    private cdr: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
    this.headerService.initialize(this.onHeaderButtonChange.bind(this));
    this.headerService.onTitleChangedCallback.pipe(
      filter(hasValue),
      untilDestroyed(this)
    ).subscribe((data: HeaderDataChanged) => {
      this.title = data.title;
      this.showBackButton = data.showBackButton;
      this.cdr.markForCheck();
    });
  }

  public navigateBack(): void {
    this.headerService.navigateBack();
  }

  // TODO: Implement types
  private onHeaderButtonChange(headerButtonComponent: any): void {
    const componentFactory: ComponentFactory<HeaderButton> = this.componentFactoryResolver.resolveComponentFactory(headerButtonComponent);
    const viewContainerRef: ViewContainerRef = this.headerButton.viewContainerRef;
    viewContainerRef.clear();
    viewContainerRef.createComponent<HeaderButton>(componentFactory);
    this.cdr.markForCheck();
  }
}
